import { useEffect, useState, React, Fragment } from "react";
import '../css/PainelAPI.css';
import NavBar from "./NavBar";
import Loading from "./loading";

function PainelIFOOD(props) {
  const [dados, setDados] = useState([]);
  const [paginaCarregada, setPaginaCarregada] = useState(false);
  const [registros, setRegistros] = useState([]); 
  const [palavraChave, setPalavraChave] = useState("");

  useEffect(() => {
    const tokenAcesso = process.env.REACT_APP_MONGO_token;
    const requestOptions = {
      headers: { token: tokenAcesso }
    };

  fetch(process.env.REACT_APP_API_IFOOD, requestOptions)
      .then(response => response.json())
      .then(data => {
        setDados(data);
        console.log(dados);
        const dadosFiltrados = data.filter((farmacia) => {
          return farmacia._id  !== 137;
        });
        setRegistros(dadosFiltrados); 
        setPaginaCarregada(true);
      })
      .catch(err => console.log(err));
  }, []);

  const Filtro = (event) => {
    const palavraChave = event.target.value.toLowerCase();
    setPalavraChave(palavraChave);
    const resultadoConsulta = dados.filter(f => 
      f._id !== 137 && 
       (f.filial.nomeFantasia.toLowerCase().includes(palavraChave) ||  f.configuracaoFilial.iFoodIdLoja.toString().includes(palavraChave) || f._id.toString().includes(palavraChave) )
    );
    setRegistros(resultadoConsulta);
  };

  if (!paginaCarregada) {
    return <Loading />;
  }

  let totalResultado = 0;

  return (
    <div>
      <div className="menu">
        <NavBar />
        <div className="max-w-screen-2xl  ml-20 mr-1 flex-1">
          <div className="flex flex-col pb-4 " >
            <div className="relative mt-4 mb-4 flex w-full flex-wrap items-stretch">
              <input
                type="search"
                className="relative m-0 block flex-auto rounded border border-solid border-neutral-300 
                              bg-transparent bg-clip-padding px-3 py-[0.25rem] text-base font-normal leading-[1.6]
                               text-neutral-100 outline-none transition duration-200 ease-in-out focus:z-[3] 
                               focus:border-primary focus:text-neutral-100 focus:shadow-[inset_0_0_0_1px_rgb(59,113,202)] focus:outline-none
                               dark:border-neutral-600
                               dark:text-neutral-200
                              dark:placeholder:text-neutral-200 dark:focus:border-primary"
                placeholder="Pesquisa"
                aria-label="Pesquisa"
                aria-describedby="button-addon2"
                onChange={Filtro}
              />
            </div>
          </div>
          <div className="max-w-screen-2xl">
            <table style={{ backgroundColor: '#27293D' }} className="min-w-full divide-y  divide-gray-200 overflow-x-auto ">
              <thead>
                <tr style={{ backgroundColor: '#27293D' }}>
                  <th style={{ backgroundColor: '#27293D' }} className="px-3 py-2 text-white">GIA</th>
                  <th style={{ backgroundColor: '#27293D' }} className="px-3 py-2 text-white">Nome</th>
                  <th style={{ backgroundColor: '#27293D' }} className="px-3 py-2 text-white">ID IFOOD</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-black">
                {registros
                 .sort((a, b) => a.filial.nomeFantasia.localeCompare(b.filial.nomeFantasia))
                .map((farmacia, index) => (
                  totalResultado = totalResultado + 1,
                  <Fragment key={index}>
                    <tr style={{ backgroundColor: '#27293D' }}>
                      <td style={{ backgroundColor: '#27293D' }} className="px-3 py-2 text-white">{farmacia._id}</td>
                      <td style={{ backgroundColor: '#27293D' }} className="px-3 py-2 text-white">{farmacia.filial.nomeFantasia}</td>
                      <td style={{ backgroundColor: '#27293D' }} className="px-3 py-2 text-sm leading-5 font-semibold text-white">{farmacia.configuracaoFilial.iFoodIdLoja}</td>
                    </tr>
                  </Fragment>
                ))}
              </tbody>
            </table>
            <p className="text-white">Resultados Encontrados: {totalResultado}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PainelIFOOD;
